import originData from './BRCity.json';

function getCityData(level) {
	let provinceData = [],
		cityData = [],
		areaData = [];
	if (level >= 1 && !provinceData.length) {
		provinceData = originData.map(province => {
			const { code, name } = province;
			return { code, name };
		});
	}
	if (level >= 2 && !cityData.length) {
		cityData = originData.map(province => {
			const { code, name, cityList } = province;
			return {
				code,
				name,
				children: cityList.map(city => {
					const { code, name } = city;
					return { code, name };
				})
			};
		});
	}
	if (level >= 3 && !areaData.length) {
		areaData = originData.map(province => {
			const { code, name, cityList } = province;
			return {
				code,
				name,
				children: cityList.map(city => {
					const { code, name, areaList } = city;
					return {
						code,
						name,
						children: areaList.map(area => {
							const { code, name } = area;
							return { code, name };
						})
					};
				})
			};
		});
	}

	return [[], provinceData, cityData, areaData];
}

export default getCityData(3);



// WEBPACK FOOTER //
// ./src/components/Address/BRCityData.js